<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="ofertas.content"
      :expanded.sync="expanded"
      class="mt-5"
      :loading="loading"
      :server-items-length="ofertas.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhuma oferta encontrada"
      loading-text="Carregando ofertas..."
      :options="optionsList"
    >
      <template v-slot:item.titulo="{ item }">
        <px-oferta-promocao :oferta="item"/>
        <px-oferta-destaque :oferta="item"/>
        <px-oferta-grade :oferta="item"/>
        {{ item.titulo }}
      </template>
      <template v-slot:item.quantidade="{ item }">
        {{ item.quantidade }} {{ item.unidadeMedida.descricao }}
      </template>
      <template v-slot:item.precoAVista="{ item }">
        {{ item.precoAVista | currency }}
      </template>
      <template v-slot:item.precoAPrazo="{ item }">
        {{ item.precoAPrazo | currency }}
      </template>
      <template v-slot:item.ativo="{ item }">
        <px-ativo-custom small :ativo="item.ativo"/>
        <v-chip label small class="ml-1"
                v-if="!item.disponivel"
                 color="secondary">Indisponível</v-chip>
      </template>
      <template v-slot:item.options="{ item }">
        <v-btn icon
               @click="goToEditConfiguracao(item, false)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn icon
                   v-on="on"
                   @click="goToViewOferta(item)">
              <v-icon>mdi-comment-question</v-icon>
            </v-btn>
          </template>
          <span>
            Ver perguntas
          </span>
        </v-tooltip>
        <v-btn icon
               link
               :href="publicOfertaUrl(item)"
               target="_blank">
          <v-icon>mdi-open-in-new</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <px-confirm-dialog ref="confirm"/>
  </div>
</template>

<script>
const MARKETPLACE_URL = process.env.VUE_APP_MARKETPLACE_APP_URL;

export default {
  props: {
    ofertas: Object,
    default: [],
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
  },
  data() {
    return {
      expanded: [],
      footerOptions: {
        itemsPerPageOptions: [5, 10, 15, 20],
        itemsPerPageText: 'Linhas por página',
      },
      headers: [
        {
          text: 'Título',
          value: 'titulo',
        },
        {
          text: 'Configuração',
          value: 'configuracaoVenda.nome',
        },
        {
          text: 'Categoria',
          value: 'categoria.descricao',
        },
        {
          text: 'Quantidade mínima',
          value: 'quantidade',
        },
        {
          text: 'Preço à vista',
          value: 'precoAVista',
        },
        {
          text: 'Preço a prazo',
          value: 'precoAPrazo',
        },
        {
          text: 'Ativo',
          value: 'ativo',
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
      ],
    };
  },
  computed: {
    publicOfertaUrl() {
      return (item) => `${MARKETPLACE_URL}oferta/${item.id}`;
    },
  },
  methods: {
    updateOptions(options) {
      this.onChangeOptions(options);
    },
    goToEditConfiguracao(item) {
      this.$router.push({
        name: 'main.marketplace.oferta.edicao',
        params: {
          id: item.id,
        },
      });
    },
    goToViewOferta(item) {
      this.$router.push({
        name: 'main.marketplace.oferta.detalhes',
        params: {
          id: item.id,
        },
      });
    },
  },
};
</script>
